module.exports = __webpack_public_path__ + "static/img/upiPopBk.d9f4cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/upiPopBk.png
// module id = vZwb
// module chunks = 0